export default __webpack_public_path__ + "img/e58cd7fe931d91b2946d10e34c0f9155.mp4";